// extracted by mini-css-extract-plugin
module.exports = {"networkBlock":"NetworkCard_networkBlock__NPYuw","networkBlock_img":"NetworkCard_networkBlock_img__Jx_qy","networkBlock_text":"NetworkCard_networkBlock_text__Uk6uc"};